export default "__VITE_ASSET__$oPi5aeU__"